module.exports = __webpack_public_path__ + "img/RORBPJR32045.d8e19888.png";